if (!customElements.get('featured-slider')) {
  class FeaturedSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.options = {
        slidesPerView: 2,
        spaceBetween: 16,
        a11y: {
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
        },
        navigation: {
          nextEl: this.querySelector('.swiper-arrow--next'),
          prevEl: this.querySelector('.swiper-arrow--prev'),
        },
      };

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('featured-slider', FeaturedSlider);
}
